// Fixed Asset Types Mutations

export const updateFixedAssetTypesList = (state, payload) => {
  state.fixedAssetTypesList = payload
}

export const fetchFixedAssetTypeInfo = (state, payload) => {
  state.fixedAssetTypeInfo = payload
}

export const updateFullFixedAssetTypesList = (state, payload) => {
  state.fullFixedAssetTypesList = payload
}
